import { reqGet } from './index';

export const fetchCountByCategory = param => reqGet('/v3/api/common/statistics/count-by-category/count', param);
